import styled, { css, createGlobalStyle } from 'styled-components/macro';
import { fonts, mediaQuery } from '@noths/styles-config';

const disableOldNav = `
  [global-component].gc-header .gc-header-menu {
    display: none !important;
    width: 0px !important;
    height: 0px !important;
    overflow: hidden !important;
  }
`;

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: ${fonts.family.v2};
    box-sizing: border-box;
  }
  
  ${disableOldNav}
`;

export const fixedWidthContent = css`
  margin: 0 auto;
  max-width: 960px;
  padding: 0 20px;
  ${mediaQuery('mobile')} {
    padding: 0 16px;
  }
`;

export const Page = styled.div`
  ${fixedWidthContent}
  margin-bottom: 10px;
`;
